import React from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
}

// 统一 KPI 指标卡：指标名 + 主要数值 + 口径/辅助信息
const MetricCard: React.FC<MetricCardProps> = ({ label, value, hint }) => {
  return (
    <div className="metric-card">
      <span className="metric-label">{label}</span>
      <span className="metric-value">{value}</span>
      {hint && <span className="metric-hint">{hint}</span>}
    </div>
  );
};

export default MetricCard;
